import React from 'react'
import { Navigate } from 'react-router-dom'

const PrivateRoute = ({ children, allowedto, blockGuests }) => {
  const isAuthenticated = localStorage.getItem('userToken')
  let hasRequiredRole
  if (isAuthenticated) {
    const user = JSON.parse(isAuthenticated)
    const isGuest = user.is_guest === 1 || user.is_guest === true || user.isGuest === 1 || user.isGuest === true
    hasRequiredRole = (allowedto ? allowedto.includes(user.type) : true) && !(blockGuests && isGuest)
  }
  return isAuthenticated ? (
    hasRequiredRole ? (
      children
    ) : (
      <Navigate
        to='/dashboard'
        replace
      />
    )
  ) : (
    <Navigate
      to='/'
      replace
    />
  )
}

export default PrivateRoute
